const MAX_AGE = 24 * 60 * 60 * 1000;
const cacheKey = apiUrl => `fdwa_branding:${apiUrl.replace(/\/$/, '')}`;
const imageId = value => typeof value === 'string' && value.trim() !== '#'
  ? value.trim() : '';

// Cache only public branding, never the settings document or authentication data.
export const brandingFromSettings = (settings = {}) => ({
  webLogoImage: imageId(settings.webLogoImage),
  webLogoImageSquare: imageId(settings.webLogoImageSquare),
  useSquareWebLogo: !!settings.useSquareWebLogo,
  companyName: typeof settings.companyName === 'string' ? settings.companyName : '',
});

export function readBranding(apiUrl) {
  try {
    const cached = JSON.parse(localStorage.getItem(cacheKey(apiUrl)));
    if (!cached || typeof cached.savedAt !== 'number' || Date.now() - cached.savedAt > MAX_AGE) return undefined;
    const branding = brandingFromSettings(cached.branding);
    return branding.webLogoImage || branding.webLogoImageSquare ? branding : undefined;
  } catch { return undefined; }
}

export function saveBranding(apiUrl, branding) {
  try {
    // Re-check absence on the next visit so adding a tenant logo never flashes BringFood.
    if (!branding.webLogoImage && !branding.webLogoImageSquare) localStorage.removeItem(cacheKey(apiUrl));
    else localStorage.setItem(cacheKey(apiUrl), JSON.stringify({ savedAt: Date.now(), branding }));
  } catch { /* Browsing with storage disabled must still work. */ }
}

export function logoCandidates(branding, preferSquare = false) {
  if (!branding) return [];
  const wide = { id: branding.webLogoImage, square: false };
  const square = { id: branding.webLogoImageSquare, square: true };
  return (branding.useSquareWebLogo || preferSquare ? [square, wide] : [wide, square])
    .filter((logo, index, all) => logo.id && all.findIndex(other => other.id === logo.id) === index);
}
